import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";

/**
 * Indica si hay una sesión de Cognito activa. Mismo criterio que el Navbar legacy (hay tokens en
 * `fetchAuthSession`), pero además escucha `signedIn`/`signedOut` para reaccionar sin recargar.
 *
 * Devuelve `null` mientras se consulta la sesión: así una protección de ruta puede esperar en lugar
 * de mandar al login a alguien que sí tiene sesión. Para mostrar/ocultar UI, `null` cuenta como
 * "sin sesión".
 */
const useIsAuthenticated = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;

    fetchAuthSession()
      .then((session) => mounted && setIsAuthenticated(session.tokens !== undefined))
      .catch(() => mounted && setIsAuthenticated(false));

    const stopListening = Hub.listen("auth", ({ payload }) => {
      if (payload.event === "signedIn") setIsAuthenticated(true);
      if (payload.event === "signedOut") setIsAuthenticated(false);
    });

    return () => {
      mounted = false;
      stopListening();
    };
  }, []);

  return isAuthenticated;
};

export default useIsAuthenticated;
